module.exports = __webpack_public_path__ + "static/media/porsche-zoom2.08f8015d.jpg";